import React, { useState, useEffect } from 'react';
import Spinner from '../../components/custom/Spinner';

interface NewSectionProps {
  //isOpen: boolean;
  onCloseWarning: () => void;
  onDiscard: () => void;
  onSave: (sectionTitle: string) => void;
  isSectionSaving: boolean;
  mode: string;
  existingSectionTitle?: string;
}

const NewSectionPopup: React.FC<NewSectionProps> = ({ onCloseWarning, onDiscard, onSave,
  isSectionSaving, mode, existingSectionTitle  
 }) => {
   
const [sectionTitle, setSectionTitle] = useState('');

useEffect(() => {
    setSectionTitle(existingSectionTitle?.trim() || "");
  }, [existingSectionTitle]);

  const buttonLabel = isSectionSaving ? mode === "New"
          ? "Saving..."
          : "Updating..."
          : mode === "New"
            ? "Save"
            : "Update";

 return (
  <div style={styles.sectionOverlay}>
    <div style={styles.sectionContainer}>
      <button style={styles.sectionCloseBtn} 
            onClick={onCloseWarning}>×</button>

      {/* Line 2: Important Label */}
      <div style={styles.sectionheaderTitle}>
        {mode === "New" ? 'Add New Section' : 'Edit Section Name'}        
      </div>

      <div style={styles.inputGroup}>
      <div style={styles.sectionTitle}>
      Section Title<span style={styles.optionalField}>(Optional field)</span>
      </div>
        <input
        type="text"
        placeholder="Enter Section Title"
        value={sectionTitle}
        onChange={(e) => setSectionTitle(e.target.value)}
        style={styles.sectionInput}
            />  
      </div>
      <div style={styles.buttonGroup}>
        <button style={styles.discardButton} onClick={onDiscard}>Discard</button>
        <button style={styles.saveButton} onClick={() => onSave(sectionTitle.trim())}
        disabled={isSectionSaving}
        >
          {isSectionSaving && <Spinner />}
          {buttonLabel}
          </button>
      </div>
    </div>
    </div>
  );
};

export default NewSectionPopup;

const styles: { [key: string]: React.CSSProperties } = {

  sectionOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  sectionContainer: {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '12px',
    width: '60%',
    maxWidth: '450px',
    maxHeight: '45%',
    overflowY: 'auto',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    textAlign: 'center',
    animation: 'fadeIn 0.3s ease-in-out',
  },

  sectionCloseBtn: {
    position: 'absolute',
    top: '15px',
    right: '20px',
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#666',
  },
  sectionheaderTitle: {
    color: '#363636',
    textAlign: 'center',
    fontFamily: "'Merriweather Sans', sans-serif",
    fontSize: '28px',
    fontWeight: 'bold',
    letterSpacing: '0',
    opacity: 1,
    marginBottom: '30px',
    //justifyContent: 'left',
  },
  inputGroup: {
    paddingLeft: '20px',
    paddingRight: '20px', 
    marginBottom: '20px', 
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start', 
  },
  sectionTitle: {
    color: '#363636',
    textAlign: 'left',
    fontFamily: "'Merriweather Sans', sans-serif",
    fontSize: '20px',
    letterSpacing: '0',
    opacity: 1,
     marginBottom: '20px',
  },
  optionalField: {
    fontSize: '14px', 
    color: '#A0A0A0',
    fontWeight: 'normal',
    marginLeft: '8px',
    position: 'relative',
    top: '-1px'
  },
  sectionInput: {
    display: 'flex',
    justifyContent: 'center',
    textAlign: 'left',
    width: '350px',
    height: '40px',
    background: '#FFFFFF 0% 0% no-repeat padding-box',
    boxShadow: '0px 3px 6px #00000029',
    borderRadius: '2px',
    opacity: 1,
    paddingLeft: '20px', 
  },
  saveButton: {
    //marginTop: '20px',
    padding: '12px 25px',
    backgroundColor: '#3E767A',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
    width: '50%',
  },
  discardButton: {
    //marginTop: '20px',
    padding: '12px 25px',
    backgroundColor: '#E2E1E1',
    color: 'black',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
    width: '40%',
  },
    buttonGroup: {
    display: 'flex',
    justifyContent: 'center',
    gap: '20px',
    //padding: '10px',
    paddingBottom: '0px',
  },

};
